// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".oKYfRIJpaR1RocwvmLZb{display:flex;flex-direction:row;justify-content:space-between;align-items:center;cursor:pointer;height:72px;background:#fff;border-radius:10px;border:2px solid #cbd5e0;padding:10px 20px;width:100%}@media(min-width: 768px){.oKYfRIJpaR1RocwvmLZb{height:100px}}.aQ8vDbI5gNsytxh7nFlO{line-height:1.2;padding-right:6px;text-overflow:ellipsis;overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"specialityCard": "oKYfRIJpaR1RocwvmLZb",
	"specialityCardText": "aQ8vDbI5gNsytxh7nFlO"
};
export default ___CSS_LOADER_EXPORT___;
